import React, { useContext } from "react";
import { Layout } from "antd";
import Footer from "../footer";
import styles from "./style.module.scss";
import AppContext from "../../../../context/app/context";

const { Content } = Layout;
interface IProps {
  children: React.ReactNode;
}

const LayoutContent: React.FC<IProps> = ({ children }) => {
  const { screenSize } = useContext(AppContext);
  return (
    <Content className={styles.layoutOuterContent}>
      <div className={screenSize == 'laptopOrDesktop' ? styles.layoutInnerContent : styles.layoutInnerContentMobile}>{children}</div>
      <Footer />
    </Content>
  );
};

export default LayoutContent;
